export enum FeatureEntitlements {
  CollectionProductPinning = 'collection_product_pinning',
}
